// شارة الرقم المرجعي: {COMPANY}-{TYPE}-{BRANCH}-{YYYY}-{0000}
export const RefBadge = ({ value, className = "" }) => {
  if (!value) return null;
  return (
    <span
      dir="ltr"
      data-testid="ref-badge"
      className={`inline-block rounded-md bg-primary/10 px-2 py-0.5 num font-mono text-[11px] font-bold text-primary ${className}`}
    >
      {value}
    </span>
  );
};
